import { BaseEnumStatic } from "../BaseEnum";

export class EsgGraphNodeTypes extends BaseEnumStatic {
  static QUESTION = 1;
  static ANSWER = 2;
  static STATUS = 3;
  static RECALL = 4;

  static Codes = [this.QUESTION, this.ANSWER, this.STATUS, this.RECALL];
  static Labels = ["QUESTION", "ANSWER", "STATUS", "RECALL"];
}
